import React, {useMemo} from 'react';
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";


const getMenuItemKey = (id, index) => `${id}-menuitem-${index}`

export const BaseSelect = ({id, label, value, name, content, setFieldValue, setFieldTouched, helperText, error, touched, disabled, ...props}) => {
    const data = useMemo(() => content.choices.map((el, index) => ({...el, id: String(index)})), [content])
    
    const onChange = (e) => {
        setFieldValue(name, data[e.target.value])
        if (!touched && setFieldTouched) {
            setFieldTouched(name, true, false)
        }
    }

    return (
                <TextField
                    id={`${id}`}
                    value={value?.id}
                    onChange={onChange}
                    defaultValue={""}
                    error={touched && Boolean(error?.value)}
                    helperText={error?.value && touched ? error?.value : helperText}
                    label={label}
                    variant={'outlined'}
                    size={'small'}
                    disabled={disabled}
                    select
                    fullWidth
                >
                    {data?.map((el, index) =>
                        <MenuItem key={getMenuItemKey(id, index)}
                                value={index}>
                            {el.value}
                        </MenuItem>)}
                </TextField>
            );     
            
}